import { createFileRoute } from "@tanstack/react-router";
import { useUserState } from "src/components/UserState";
import SingleSelectionPageComponent from "src/features/SingleSelectionPageComponent";

export const Route = createFileRoute("/_layout/equipment")({
  component: RouteComponent,
});

function RouteComponent() {
  const setSelections = useUserState((state) => state.setSelections);

  return (
    <SingleSelectionPageComponent
      titleText="What equipment do you have?"
      bodyText="Let us know what equipment you have access to."
      items={[
        {
          id: "none",
          label: "No equipment",
        },
        {
          id: "few_at_home",
          label: "A few items at home",
        },
        {
          id: "apartment_gym",
          label: "Apartment/Hotel gym",
        },
        {
          id: "full_gym_access",
          label: "Full gym access",
        },
      ]}
      onSelectionChange={(selectedItem) => {
        console.log(selectedItem);
        if (selectedItem !== null) {
          setSelections("/equipment", [selectedItem]);
        } else {
          setSelections("/equipment", undefined);
        }
      }}
    />
  );
}
